import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

/**
 * A custom element that manages a cart drawer.
 *
 * @extends {DialogComponent}
 */
class CartDrawerComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  #handleCartAdd = () => {
    if (this.hasAttribute('auto-open')) {
      this.showDialog();
    }
  };

  open() {
    this.showDialog();

    /**
     * Close cart drawer when installments CTA is clicked to avoid overlapping dialogs
     */
    customElements.whenDefined('shopify-payment-terms').then(() => {
      const installmentsContent = document.querySelector('shopify-payment-terms')?.shadowRoot;
      const cta = installmentsContent?.querySelector('#shopify-installments-cta');
      cta?.addEventListener('click', this.closeDialog, { once: true });
    });
  }

  close() {
    this.closeDialog();
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}

document.addEventListener("click", async function (e) {
  const btn = e.target.closest(".size-btn");
  if (!btn) return;

  e.preventDefault();
  e.stopPropagation();

  if (btn.classList.contains("disabled")) return;
  btn.classList.add("disabled");

  let newVariantOptions;
  try {
    newVariantOptions = JSON.parse(btn.dataset.variantOptions);
  } catch (err) {
    console.error("Invalid variant options:", btn.dataset.variantOptions);
    btn.classList.remove("disabled");
    return;
  }

  const oldLineKey = btn.dataset.lineKey;
  const productHandle = btn.closest("[data-product-handle]").dataset.productHandle;

  const productData = await fetch(`/products/${productHandle}.js`).then(r => r.json());

  const matchedVariant = productData.variants.find(v => {
    return JSON.stringify(v.options) === JSON.stringify(newVariantOptions);
  });

  if (!matchedVariant) {
    console.error("Variant not found for:", newVariantOptions);
    btn.classList.remove("disabled");
    return;
  }

  const newVariantId = matchedVariant.id;

  await fetch("/cart/change.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ id: oldLineKey, quantity: 0 })
  });

  document.querySelector('.change_size_form').value = newVariantId;
  document.getElementById('changeSizeForm')?.querySelector('button')?.click();
  // await fetch("/cart/add.js?no_event=1", {
  //   method: "POST",
  //   headers: { "Content-Type": "application/json" },
  //   body: JSON.stringify({ id: newVariantId, quantity: 1 })
  // });

  // window.location.reload();
});